
import V3GameDifficultyTitle from './v3-game-difficulty-title.vue';
import { groupItemMixin, jsonGroupItemMixin } from '@/views/creative/mixin/index.js';
import GroupItemHeader from './group-item-header.vue';
import ElCustomColorPicker from '@com/components/vue-colorpicker/index.vue';

export default {
  mixins: [groupItemMixin, jsonGroupItemMixin],

  components: {
    V3GameDifficultyTitle: V3GameDifficultyTitle,
    GroupItemHeader: GroupItemHeader,
    ElCustomColorPicker: ElCustomColorPicker
  },

  props: {
    config: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      innerConfig: null
    };
  },


  computed: {
    formItem: function formItem() {
      return {
        rules: [{
          required: true,
          trigger: ['blur', 'change']
        }],
        field: {
          class: 'game-config-color-picker'
        }
      };
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.innerConfig = this.config;
    this.$nextTick(function () {
      _this.$refs.form && _this.$refs.form.validate && _this.$emit('add-validator', _this.$refs.form.validate);
    });
  },


  watch: {
    innerConfig: {
      handler: function handler(val) {
        this.$emit('update', val);
      },

      deep: true
    }
  },

  methods: {
    handleChange: function handleChange() {
      var _this2 = this;

      this.$nextTick(function () {
        return _this2.$refs.form && _this2.$refs.form.validate();
      });
    }
  }
};